import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sjfjb7psuq: FaireBrandEntity = {
  token: "b_sjfjb7psuq",
  type: "brand",
  name: "Queens",
  avatarUrl:
    "https://cdn.faire.com/fastly/abba8acb805124ff83541583efa01bbbdad851eaba124cc49910e49926dfed42.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/88a3fcf2ec30bd3d5d2829bb4ba68443f74fdb41267e84e7c1914e798efe68e6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/abba8acb805124ff83541583efa01bbbdad851eaba124cc49910e49926dfed42.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/88a3fcf2ec30bd3d5d2829bb4ba68443f74fdb41267e84e7c1914e798efe68e6.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 95,
  rating: 5,
  reviewCount: 19,
  isInsider: true,
  description:
    "Queens is a creator of friendly Korean American ingredients that are good for people and the planet. Drawing inspiration from the very best local farms and in the style of traditional methods in fermentation and preservation, our products bring people closer to distinctive Korean flavors without relying on importing that’s harsh on the environment. We buy sustainably and directly from the source, process all our produce and raw ingredients in-house in our San Francisco facility, and make something extraordinary because it tastes like what it is. ",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:08.670Z",
    importedBy: "entity-db-cli",
  },
};
